// ==================== CART FUNCTIONALITY ====================

document.addEventListener('DOMContentLoaded', function() {
  updateCartCount();
});

function updateCartCount() {
  const cartCount = document.querySelectorAll('.cart-count');
  if (cartCount.length === 0) return;

  fetch('/cart.json')
    .then(res => res.json())
    .then(data => {
      cartCount.forEach(el => el.textContent = data.item_count);
      renderCartDrawer(data);
    })
    .catch(err => console.error('Error:', err));
}

function formatMoney(amount, currency = 'USD') {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
  }).format(amount / 100);
}

function renderCartDrawer(cart) {
  const drawer = document.getElementById('cart-drawer');
  const itemsContainer = document.getElementById('cart-drawer-items');
  const drawerCount = document.querySelector('.cart-drawer__count');
  const subtotal = document.getElementById('cart-drawer-subtotal');
  if (!itemsContainer || !drawerCount || !subtotal || !cart) return;

  drawerCount.textContent = `${cart.item_count} item${cart.item_count === 1 ? '' : 's'}`;
  subtotal.textContent = formatMoney(cart.total_price, cart.currency || 'USD');

  if (cart.item_count === 0) {
    itemsContainer.innerHTML = '<p class="cart-drawer__empty">Your cart is empty.</p>';
    return;
  }

  itemsContainer.innerHTML = cart.items.map(item => {
    const imageURL = item.image || 'https://via.placeholder.com/160';
    return `
      <div class="cart-item">
        <div class="cart-item__media">
          <img src="${imageURL}" alt="${item.title}">
        </div>
        <div class="cart-item__details">
          <div class="cart-item__title">${item.title}</div>
          <div class="cart-item__variant">${item.variant_title || 'Default'}</div>
          <div class="cart-item__price">${formatMoney(item.final_line_price, cart.currency || 'USD')}</div>
          <div class="cart-item__quantity">
            <button type="button" class="cart-item-qty-btn" data-action="decrease" data-key="${item.key}">−</button>
            <span>${item.quantity}</span>
            <button type="button" class="cart-item-qty-btn" data-action="increase" data-key="${item.key}">+</button>
          </div>
          <div class="cart-item__remove">
            <a href="#" class="cart-item__remove-link" data-key="${item.key}">Remove</a>
          </div>
        </div>
      </div>
    `;
  }).join('');
}

function openCartDrawer() {
  const drawer = document.getElementById('cart-drawer');
  if (!drawer) return;
  drawer.classList.add('active');
  drawer.setAttribute('aria-hidden', 'false');
  updateCartCount();
}

function closeCartDrawer() {
  const drawer = document.getElementById('cart-drawer');
  if (!drawer) return;
  drawer.classList.remove('active');
  drawer.setAttribute('aria-hidden', 'true');
}

function changeCartItem(itemKey, quantity) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
    },
    body: new URLSearchParams({
      id: itemKey,
      quantity: quantity
    })
  })
    .then(res => res.json())
    .then(data => {
      updateCartCount();
      if (document.getElementById('cart-drawer').classList.contains('active')) {
        renderCartDrawer(data);
      }
    })
    .catch(err => console.error('Error:', err));
}

document.addEventListener('click', function(e) {
  const cartToggle = e.target.closest('.cart-toggle');
  if (cartToggle) {
    e.preventDefault();
    openCartDrawer();
    return;
  }

  if (e.target.closest('[data-cart-close]') || e.target.closest('.cart-drawer__close')) {
    closeCartDrawer();
    return;
  }

  const qtyButton = e.target.closest('.cart-item-qty-btn');
  if (qtyButton) {
    const key = qtyButton.dataset.key;
    const action = qtyButton.dataset.action;
    const itemRow = qtyButton.closest('.cart-item');
    const qtyDisplay = itemRow.querySelector('.cart-item__quantity span');
    const currentQty = parseInt(qtyDisplay.textContent, 10);
    const nextQty = action === 'increase' ? currentQty + 1 : Math.max(0, currentQty - 1);
    if (nextQty >= 0) {
      changeCartItem(key, nextQty);
    }
    return;
  }

  const removeLink = e.target.closest('.cart-item__remove-link');
  if (removeLink) {
    e.preventDefault();
    const key = removeLink.dataset.key;
    changeCartItem(key, 0);
    return;
  }
});

// Add to cart event listener
document.addEventListener('submit', function(e) {
  if (e.target.classList.contains('product-form')) {
    e.preventDefault();
    const formData = new FormData(e.target);
    
    fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    })
    .then(res => res.json())
    .then(data => {
      updateCartCount();
      alert('Product added to cart!');
    })
    .catch(err => console.error('Error:', err));
  }
});

// ==================== SMOOTH SCROLL ====================

document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function(e) {
    e.preventDefault();
    const target = document.querySelector(this.getAttribute('href'));
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  });
});

// ==================== FORM VALIDATION ====================

function validateEmail(email) {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return regex.test(email);
}

// ==================== LAZY LOADING ====================

if ('IntersectionObserver' in window) {
  const imageObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const img = entry.target;
        if (img.dataset.src) {
          img.src = img.dataset.src;
          img.classList.add('loaded');
          observer.unobserve(img);
        }
      }
    });
  });

  document.querySelectorAll('img[data-src]').forEach(img => imageObserver.observe(img));
}

console.log('Shopify Jewelry Store theme loaded!');